<template>
  <div class="axe-animation-wrap pt-20 pb-20">
    <div class="container mx-auto px-6">

      <!-- Titre principal -->
      <h2 class="text-3xl font-bold text-center mb-8 text-yellow-700 uppercase">
        Axe Animation animée
      </h2>

      <!-- Introduction -->
      <div class="content-text mb-6">
        <h3 class="text-xl font-semibold text-primary mb-2">« EITP en mission » – Axe Animation</h3>

        <h5 class="fw-semibold text-primary">Objectif</h5>
        <p>
          Formation à grande échelle sur les questions de foi et de vie de foi, 
          et mise à disposition d’un corps de formateurs pour animations de conférences et de récollections.
        </p>
      </div>

      <div class="content-text mb-6">
        <h5 class="fw-semibold text-primary">Intérêt</h5>
        <ul>
          <li>Extension de la formation à un plus grand nombre de fidèles (associations, conseils, chorales) ;</li>
          <li>Modeste participation au <em>Munus docendi</em> des curés et pasteurs, au regard de leurs nombreuses charges pastorales.</li>
        </ul>
      </div>

      <div class="content-text mb-6">
        <h5 class="fw-semibold text-primary">Déroulement pour les conférences</h5>
        <ul>
          <li><strong>Modalités de la formation :</strong> Formation participative, avec divers supports visuels.</li>
          <li><strong>Période et durée :</strong> Mercredi, samedi ou dimanche ; chaque séance dure 2 h 30 à 3 h.</li>
          <li><strong>Nombre de participants :</strong> 50 au maximum par séance, animée par deux animateurs.</li>
          <li><strong>Participation :</strong> 25.000 francs comme contribution aux diverses charges.</li>
        </ul>
      </div>

      <div class="content-text mb-6">
        <h5 class="fw-semibold text-primary">Référents</h5>
        <ul>
          <li><strong>Responsable du Projet :</strong> École d’Initiation Théologique et Pastorale (EITP)</li>
          <li><strong>Animateurs :</strong> Disciples d’Emmaüs, formés à l’EITP et sous la responsabilité de l’EITP</li>
        </ul>
        <p>Pour toutes particularités, nous sommes disponibles à échanger avec vous.</p>
      </div>

      <hr class="my-6 border-gray-300" />

      <div class="content-text">
        <h5 class="fw-semibold text-primary mb-3">Formations ou actions prévues pour 2020 – 2021</h5>
        <div class="table-responsive">
          <table class="table table-bordered w-full text-left">
            <thead class="table-light">
              <tr>
                <th class="p-2 border">#</th>
                <th class="p-2 border">Thèmes</th>
                <th class="p-2 border">Période</th>
                <th class="p-2 border">Observations</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="p-2 border">1</td>
                <td class="p-2 border">Présentation de la lettre pastorale</td>
                <td class="p-2 border">Octobre – Décembre</td>
                <td class="p-2 border">Pour le peuple de Dieu</td>
              </tr>
              <tr>
                <td class="p-2 border">2</td>
                <td class="p-2 border">
                  « Sur les pas des missionnaires » :<br />Pèlerinage Ouidah – Agoué
                </td>
                <td class="p-2 border">Février – Mars</td>
                <td class="p-2 border">Dans le cadre des 160 ans de l’évangélisation</td>
              </tr>
              <tr>
                <td class="p-2 border">3</td>
                <td class="p-2 border">
                  Prédication de Récollections<br />Pour sacrements d’initiation
                </td>
                <td class="p-2 border">Mai – Juin</td>
                <td class="p-2 border">Pour catéchumènes ou fidèles à réadmettre aux sacrements</td>
              </tr>
            </tbody>
          </table>
        </div>

        <p class="mt-3"><strong>NB :</strong> Les modalités pour le pèlerinage et les récollections sont indiquées à la carte.</p>
        <p>Au regard du nombre d’animateurs disponibles, au cas où vous seriez intéressés, vous voudriez déjà faire signe pour une bonne planification.</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "AxeAnimationPage",
  setup() {
    return {};
  },
});
</script>

<style scoped>
.axe-animation-wrap {
  background-color: #fff;
}

.section-title {
  color: #2b3a67;
  font-weight: 600;
}

.content-text ul {
  list-style-type: disc;
  padding-left: 1.5rem;
}

.table {
  border-collapse: collapse;
}

.table th,
.table td {
  border: 1px solid #ccc;
}
</style>
